import ConvidadoHistorico from './ConvidadoHistorico'

export default ConvidadoHistorico